import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import * as _ from 'lodash';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.authService.getUser();
    if (_.isEmpty(user)) {
      this.router.navigate(['login']);

      return false;
    }

    const permission = route.data.permission;

    const hasAccess = !permission || user.permissions.includes(permission);

    if (!hasAccess) {
      this.router.navigate(['error', 403]);
    }

    return hasAccess;
  }
}
